import { Component, Input, OnInit } from '@angular/core';
import { RouteState } from 'src/app/_models/state/routeState';
import { RoadTypeReportReportLineView } from '../../_models/view/roadTypeReportView';
@Component({
  selector: 'app-road-type-distance-report',
  templateUrl: './road-type-distance-report.component.html',
  styleUrls: ['./road-type-distance-report.component.scss'],
})
export class RoadTypeDistanceReportComponent implements OnInit {
  @Input() route: RouteState;
  @Input() distanceUnits: number;
  @Input() precision: number;
  roadTypeReportLines: RoadTypeReportReportLineView[] = [];
  roadTypeStopsCount: number;
  ngOnInit(): void {
    this.roadTypeStopsCount = this.route?.roadTypeReport?.ReportLines?.filter(
      (rl) => rl.Stop !== null
    ).length;

    this.roadTypeReportLines = this.route?.roadTypeReport?.ReportLines.map(
      (rl) => {
        return { ...rl };
      }
    );

    if (this.roadTypeReportLines && Array.isArray(this.roadTypeReportLines)) {
      let i = 0;
      this.roadTypeReportLines.forEach((roadTypeReportLine, index) => {
        if (roadTypeReportLine.Stop) {
          roadTypeReportLine.routeAddress = this.route.stopsState[i];
          i++;
          const addressDetails = [
            roadTypeReportLine.Stop?.Address?.StreetAddress,
            roadTypeReportLine.Stop?.Address?.City,
            roadTypeReportLine.Stop?.Address?.Zip,
            roadTypeReportLine.Stop?.Address?.State,
            roadTypeReportLine.Stop?.Address?.County,
          ]
            .filter(Boolean)
            .join();
          if (index === 0) {
            roadTypeReportLine.StopDisplay = `Origin: ${addressDetails}`;
          } else if (index === this.roadTypeStopsCount - 1) {
            roadTypeReportLine.StopDisplay = `Dest: ${addressDetails}`;
          } else {
            roadTypeReportLine.StopDisplay = `Stop ${index}: ${addressDetails}`;
          }
        }
      });
    }
  }
}
